import { appContextStore } from "../../../common/redux/appContext";
import { introProductPriceCalculator } from "../helpers/introProductPriceCalculator";
import { calculateMembersAge } from "../helpers/calculateMembersAge";

export const introCostCalculatorHook = (
  disabilitySelectedAndApproved: boolean
) => {
  const appContext = appContextStore.getState();
  const memberAge = calculateMembersAge(appContext.customerProfile.birthday);

  return introProductPriceCalculator(
    appContext.productPrices.qualifying,
    appContext.membershipHistory.totalYears.memberhsip.overall,
    disabilitySelectedAndApproved,
    memberAge,
    appContext.membershipHistory.totalYears.production.overall,
    appContext.customerProfile.isPastPresident
  );
};

export default {};
